export default __webpack_public_path__ + "images/341d83528eee31f61beb18354fe5c2a5-pyxir-rocket.svg";